import { render, staticRenderFns } from "./applicationDebt.vue?vue&type=template&id=639633fa&scoped=true&"
import script from "./applicationDebt.vue?vue&type=script&lang=js&"
export * from "./applicationDebt.vue?vue&type=script&lang=js&"
import style0 from "./applicationDebt.vue?vue&type=style&index=0&id=639633fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639633fa",
  null
  
)

export default component.exports